import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Stack, styled, Typography } from "@mui/material";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import { ForwardArrow } from "../icons/forward";
import { Container } from "../theme/common";
import { FONTSTYPO, SPACING } from "../theme/palette";
import background from "./resources/banner.svg";
const BannerStyle = styled("div")(({ pattern, theme }) => ({
    "backgroundColor": theme.palette.common.white,
    "backgroundImage": `url(${pattern})`,
    "backgroundPosition": "center bottom",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "cover",
    "color": theme.palette.common.white,
    "paddingBlock": SPACING.spacel,
    "textAlign": "center",
    "width": "100%",
}));
const TextContainer = styled("div")(() => ({
    "margin": "0px auto",
    "maxWidth": "600px",
    "paddingBlock": SPACING.spacexl
}));
const headingOverRide = {
    "fontSize": `clamp(${FONTSTYPO.step1}, calc(.5rem + 4vw), ${FONTSTYPO.step4})`,
};
const subheadingOverRide = {
    "fontSize": `clamp(${FONTSTYPO.step0}, calc(1rem + 3vw), ${FONTSTYPO.step1})`
};
const ActionStyle = styled(Button)(({ theme }) => ({
    "marginBlock": theme.spacing(2.5),
    [theme.breakpoints.down("md")]: {
        "width": "100%"
    }
}));
const HeroImageStyle = styled("div")(() => ({
    "img": {
        "maxWidth": "100%"
    }
}));
export const ProductFamilyHeroComponent = (props) => {
    const { cta, actionItemHandler, productFamilyHeroBreadcrumb, productFamilyHeroButtonText, productFamilyHeroImage, productFamilyHeroPrimaryHeading, productFamilyHeroSecondaryHeading, productFamilybgPattern } = props;
    return (_jsx(BannerStyle, Object.assign({ pattern: isNotUndefinedOrNull(productFamilybgPattern) ? productFamilybgPattern : background }, { children: _jsxs(Container, { children: [_jsxs(TextContainer, { children: [_jsxs(Stack, Object.assign({ direction: "column", spacing: 2.5 }, { children: [_jsx(Typography, Object.assign({ variant: "caption" }, { children: productFamilyHeroBreadcrumb })), _jsx(Typography, Object.assign({ sx: Object.assign({}, headingOverRide), variant: "h1" }, { children: productFamilyHeroPrimaryHeading })), _jsx(Typography, Object.assign({ sx: Object.assign({}, subheadingOverRide), variant: "h5" }, { children: productFamilyHeroSecondaryHeading }))] })), isNotUndefinedOrNull(productFamilyHeroButtonText) ? (_jsxs(ActionStyle, Object.assign({ className: isNotUndefinedOrNull(cta) && isNotUndefinedOrNull(cta.className) ? cta.className : "", color: "inherit", onClick: actionItemHandler, size: "large", variant: "contained" }, { children: [productFamilyHeroButtonText, " ", _jsx(ForwardArrow, {})] }))) : _jsx(_Fragment, { children: " " })] }), _jsx(HeroImageStyle, { children: _jsx("img", { alt: productFamilyHeroPrimaryHeading, src: productFamilyHeroImage }) })] }) })));
};
